import { useState } from "react";
import { ClipboardPaste, Languages, Loader2, Minimize2, Reply } from "lucide-react";
import { toast } from "sonner";
import api, { apiError, isPaywall } from "@/lib/api";

export const SHARED_KEY = "mulankan_shared";

const ACTIONS = [
  { id: "hindi", label: "Translate to Hindi", icon: Languages, prompt: "Translate this text into natural Hindi (Devanagari script)." },
  { id: "english", label: "Translate to English", icon: Languages, prompt: "Translate this text into natural, fluent English." },
  { id: "shorter", label: "Make shorter", icon: Minimize2, prompt: "Make this text shorter and crisper while keeping the meaning and tone." },
  { id: "reply", label: "Reply", icon: Reply, prompt: "Write a short, friendly, natural reply to this message in the same language. Return only the reply.", append: true },
];

export function QuickActions({ text, setText, opts, shared }) {
  const [busy, setBusy] = useState("");
  const run = async (a) => {
    setBusy(a.id);
    try {
      const fd = new FormData();
      fd.append("text", text);
      fd.append("instruction", a.prompt);
      if (opts.model) fd.append("model", opts.model);
      const { data } = await api.post("/dictation/command", fd);
      setText((t) => (a.append ? `${t.trimEnd()}\n\n— Reply —\n${data.text}` : data.text));
      toast.success(`${a.label} done`);
    } catch (e) {
      if (!isPaywall(e)) toast.error(apiError(e.response?.data?.detail));
    } finally {
      setBusy("");
    }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 border-t border-white/[0.06] px-4 py-3" data-testid="quick-actions">
      <span className={`text-xs ${shared ? "text-[var(--accent)] font-semibold" : "text-white/40"}`} data-testid="quick-actions-label">
        {shared ? "Shared text · quick actions" : "Quick actions"}
      </span>
      {ACTIONS.map((a) => (
        <button key={a.id} disabled={!text || !!busy} onClick={() => run(a)} data-testid={`quick-action-${a.id}`} className="pill text-xs">
          {busy === a.id ? <Loader2 size={12} className="animate-spin" /> : <a.icon size={12} />} {a.label}
        </button>
      ))}
    </div>
  );
}

export function PasteButton({ onPaste }) {
  const paste = async () => {
    try {
      const t = (await navigator.clipboard.readText()).trim();
      if (!t) { toast.message("Your clipboard is empty. Copy some text first."); return; }
      onPaste(t);
    } catch {
      toast.error("Couldn't read the clipboard. Long-press the editor and choose Paste instead.");
    }
  };
  return <button onClick={paste} data-testid="paste-polish-button" className="btn-ghost text-xs"><ClipboardPaste size={14} /> Paste & polish</button>;
}
